import React, { useState, useEffect } from "react";
import BhelLogo from "../../assets/icons/bhel-logo.svg";
import { Modal } from "antd";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { logout } from "../../redux/authSlice/authSlice";
import { PATHNAME } from "../../pathname";
import {
  LayoutDashboard,
  FolderKanban,
  FolderOpen,
  Boxes,
  Package,
  FileText,
  ClipboardList,
  Building2,
  Map,
  BookOpen,
  BarChart3,
  TrendingUp,
  Layers3,
  ShieldCheck,
  Settings,
  ChevronDown,
  ChevronRight,
  LogOut,
  PieChart,
  Database,
} from "lucide-react";

const iconMap = {
  dashboard: LayoutDashboard,
  performance: TrendingUp,
  operatingperformance: BarChart3,
  guidelines: BookOpen,
  consolidatedreports: FileText,
  reports: ClipboardList,
  projects: FolderKanban,
  unitRegion: Building2,
  packages: Package,
  products: Boxes,
  pmgList: Layers3,
  masters: Boxes,
  internalOrderMaster: FolderOpen,
  orderAllocationUpdation: ClipboardList,
  ioUnitMapping: Map,
  ioAllocation: Layers3,
  adminModule: ShieldCheck,
  dmAnalytics: PieChart,
  masterUploads: Database,
};

const SideBar = () => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openMenus, setOpenMenus] = useState([]);

  const toggleMenu = (key) => {
    setOpenMenus((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  const menuItems =
    user?.role?.toLowerCase() === 'region'
      ? [
        {
          name: 'Performance Planning',
          value: 'performance',
          path: '/performance',
        },
        {
          name: 'Operating Performance',
          value: 'operatingperformance',
          path: '/operating-performance',
        },
        {
          name: 'Approved Execution Target',
          value: 'guidelines',
          path: '/guidelines',
        },
        {
          // name: 'Budget Report',
          name: 'Performance Plan - Key Parameter',
          value: 'pmgList',
          path: '/consolidatedreports/budget-report',
        },
        // {
        //   // name: 'Actual Budget Report',
        //   name: 'Performance Plan - Comparative',
        //   value: 'pmgList',
        //   path: '/consolidatedreports/actual-budget-report',
        // },
        {
          name: 'Execution Plan',
          value: 'pmgList',
          path: '/consolidatedreports/execution-plan',
        },
        {
          name: 'Update Monitoring Non-INDAS',
          value: 'pmgList',
          path: '/non-indas-projects',
        },
      ]
      : user?.role?.toLowerCase() === 'unit'
        ? [
          {
            name: 'Performance Planning',
            value: 'performance',
            path: '/performance',
          },
          {
            name: 'Operating Performance',
            value: 'operatingperformance',
            path: '/operating-performance',
          },
          {
            name: 'Approved Execution Target',
            value: 'guidelines',
            path: '/guidelines',
          },
          {
            // name: 'Budget Report',
            name: 'Performance Plan - Key Parameter',
            value: 'pmgList',
            path: '/consolidatedreports/budget-report',
          },
          // {
          //   // name: 'Actual Budget Report',
          //   name: 'Performance Plan - Comparative',
          //   value: 'pmgList',
          //   path: '/consolidatedreports/actual-budget-report',
          // },
          {
            name: 'Execution Plan',
            value: 'pmgList',
            path: '/consolidatedreports/execution-plan',
          },
          {
            name: 'Update Monitoring Non-INDAS',
            value: 'pmgList',
            path: '/non-indas-projects',
          },
        ]
        : user?.role?.toLowerCase() === 'admin'
          ? [
            {
              name: 'Dashboard',
              value: 'dashboard',
              path: '/dashboard',
            },
            {
              name: 'Consolidated Reports',
              value: 'consolidatedreports',
              path: PATHNAME.ADMIN_CONSOLIDATED_PROJECT_WISE_REPORT,
              hasChildren: true,
              children: [
                {
                  name: 'Project wise',
                  value: '',
                  path: PATHNAME.ADMIN_CONSOLIDATED_PROJECT_WISE_REPORT,
                },
                {
                  name: 'Unit wise',
                  value: '',
                  path: PATHNAME.ADMIN_CONSOLIDATED_UNIT_WISE_REPORT,
                },
                {
                  name: 'IUT Report',
                  value: '',
                  path: PATHNAME.ADMIN_CONSOLIDATED_IUT_REPORT,
                },
                {
                  name: 'IUT & Non BHEL',
                  value: '',
                  path: PATHNAME.ADMIN_CONSOLIDATED_IUT_NON_BHEL_REPORT,
                },
                {
                  name: 'Yearly Charts',
                  value: '',
                  path: PATHNAME.ADMIN_CONSOLIDATED_YEARLY_CHART,
                },
                {
                  name: 'Qtrly. Charts',
                  value: '',
                  path: PATHNAME.ADMIN_CONSOLIDATED_QUARTERLY_CHART,
                },

                {
                  name: 'Order Outstanding',
                  value: 'pmgList',
                  path: '/consolidatedreports/order-outstanding',
                },
                {
                  // name: 'Budget Report',
                  name: 'Performance Plan - Key Parameter',
                  value: 'pmgList',
                  path: '/consolidatedreports/budget-report',
                },
                // {
                //   // name: 'Actual Budget Report',
                //   name: 'Performance Plan - Comparative',
                //   value: 'pmgList',
                //   path: '/consolidatedreports/actual-budget-report',
                // },
                {
                  name: 'Execution Plan',
                  value: 'pmgList',
                  path: '/consolidatedreports/execution-plan',
                },
                {
                  name: 'Business Sector Execution Plan',
                  value: 'pmgList',
                  path: PATHNAME.ADMIN_CONSOLIDATED_BUSINESS_SECTOR_WISE_EXECUTION_PLAN,
                },
                {
                  name: 'Project Unit Wise Planning',
                  value: 'pmgList',
                  path: PATHNAME.ADMIN_CONSOLIDATED_PROJECT_UNIT_WISE_PLANNING,
                },
                {
                  name: 'Reports',
                  value: 'reports',
                  path: PATHNAME.ADMIN_REPORTS,
                },
                {
                  name: "Operating Performance ",
                  value: "operatingPerformance",
                  path: "",
                  hasChildren: true,
                  children: [
                    {
                      name: "Operating Performance",
                      value: 'operatingPerformance',
                      path: "/operating-performance-report",


                    },
                    {
                      name: "Unit Month Wise",
                      value: 'operatingPerformance',
                      path:
                        "/operating-performance-unit-wise-report",
                    },
                    {
                      name: "Unit Quarter Wise",
                      value: 'operatingPerformance',
                      path:
                        "/operating-performance-quarter-wise-report",
                    },
                  ],
                },
              ],
            },
            {
              name: "DM Analytics",
              value: "dmAnalytics",
              path: "/dm-analytics",
              hasChildren: true,
              children: [
                {
                  name: "Project Wise Report",
                  value: "",
                  path: PATHNAME.ADMIN_DM_ANALYTICS_PROJECT_WISE_REPORT,
                },
                {
                  // name: "Unit Wise Report",
                  name: "Project Wise - Unit Wise",
                  value: "",
                  path: PATHNAME.ADMIN_DM_ANALYTICS_UNIT_WISE_REPORT,
                },
                {
                  // name: "Report",
                  name: "Unit Wise - Project Wise ",
                  value: "",
                  path: PATHNAME.ADMIN_DM_ANALYTICS_REPORT,
                },
                {
                  name: "Critical/Major Products",
                  value: "",
                  path: PATHNAME.ADMIN_DM_ANALYTICS_CRITICAL_PRODUCTS_REPORT,
                },
                {
                  name: "MW Project Wise",
                  value: "",
                  path: PATHNAME.ADMIN_DM_ANALYTICS_MW_PROJECT_WISE_REPORT,
                },
                {
                  // name: "Report",
                  name: "Charts",
                  value: "",
                  path: PATHNAME.ADMIN_DM_ANALYTICS_CHARTS,
                },
              ],
            },
            {
              name: 'Unit/Region',
              value: 'unitRegion',
              path: '/unit-region',
            },
            {
              name: 'Project',
              value: 'projects',
              path: PATHNAME.ADMIN_ALL_PROJECTS,
              hasChildren: true,
              children: [
                {
                  name: 'Monitoring Projects',
                  value: '',
                  path: PATHNAME.ADMIN_ACTIVE_PROJECTS,
                },
                {
                  name: 'Other Projects',
                  value: '',
                  path: PATHNAME.ADMIN_OTHER_PROJECTS,
                },
                {
                  name: 'Direct Orders',
                  value: '',
                  path: PATHNAME.ADMIN_DIRECT_ORDERS,
                },
                {
                  name: 'Anticipated Orders',
                  value: '',
                  path: PATHNAME.ADMIN_ANTICIPATED_ORDERS,
                },
                {
                  name: 'Customer Group Wise',
                  value: '',
                  path: PATHNAME.ADMIN_PROJECT_CUSTOMER_GROUP_WISE,
                },
              ],
            },
            {
              name: 'Admin',
              value: 'adminModule',
              path: '/admin-module',
              hasChildren: true,
              children: [
                {
                  name: 'All Projects',
                  value: '',
                  path: PATHNAME.ADMIN_ALL_PROJECTS,
                },
                {
                  name: 'Packages',
                  value: 'packages',
                  path: '/packages',
                },
                {
                  name: 'Products',
                  value: 'products',
                  path: '/products',
                },
                {
                  name: 'Masters',
                  value: 'masters',
                  path: PATHNAME.ADMIN_MASTERS,
                },
                {
                  name: 'Date Configuration',
                  value: 'otherProjectsDate',
                  path: PATHNAME.ADMIN_OTHER_PROJECTS_DATE,
                },
                {
                  name: 'Update REV No',
                  value: 'updateRevNo',
                  path: PATHNAME.ADMIN_UPDATE_REV_NO,
                },
                {
                  name: 'Delete IO No',
                  value: 'deleteIoNo',
                  path: PATHNAME.ADMIN_DELETE_REV_NO,
                },
                {
                  name: 'Approved Execution Target',
                  value: 'guidelines',
                  path: '/guidelines',
                },
              ],
            },
          ]
          : user?.role?.toLowerCase() === 'super_admin'
            ? [
              {
                name: 'Dashboard',
                value: 'dashboard',
                path: '/dashboard',
              },
              {
                name: 'Unit/Region',
                value: 'unitRegion',
                path: '/unit-region',
              },
              {
                name: 'Project',
                value: 'projects',
                path: PATHNAME.ADMIN_ACTIVE_PROJECTS,
                hasChildren: true,
                children: [
                  {
                    name: 'Monitoring Projects',
                    value: '',
                    path: PATHNAME.ADMIN_ACTIVE_PROJECTS,
                  },
                ],
              },
            ]
            : [];


  // Auto-open parent if child route is active
  useEffect(() => {

    if (
      location.pathname === "/operating-performance-report" ||
      location.pathname === "/operating-performance-unit-wise-report" ||
      location.pathname === "/operating-performance-quarter-wise-report"
    ) {
      setOpenMenus([
        "consolidatedreports",
        "operatingPerformance",
      ]);
      return;
    }
    const checkActive = (items, parentKey = null) => {
      items.forEach((item) => {

        const isMatch =
          item.path &&
          (location.pathname === item.path ||
            location.pathname.startsWith(item.path + "/"));

        if (isMatch && parentKey) {
          setOpenMenus([parentKey]);
        }

        if (item.children) {
          checkActive(item.children, item.value);
        }
      });
    };

    checkActive(menuItems);
  }, [location.pathname]);

  const handleLogout = () => {
    Modal.confirm({
      title: "Confirm Logout",
      content: "Are you sure you want to logout?",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      onOk: () => {
        dispatch(logout());
        navigate("/login");
      },
    });
  };
  const isMenuActive = (item) => {
    if (
      item.path &&
      (location.pathname === item.path ||
        location.pathname.startsWith(item.path + "/"))
    ) {
      return true;
    }

    if (item.children) {
      return item.children.some((child) => isMenuActive(child));
    }

    return false;
  };

  return (
    // <div className="w-[280px] h-screen bg-white border-r border-slate-200 shadow-sm flex flex-col justify-between">
    <div className="w-[280px] h-screen bg-white border-r border-slate-200 shadow-sm flex flex-col overflow-hidden">

      {/* Logo */}
      {/* <div className="flex flex-col h-full"> */}
      <div className="flex flex-col flex-1 min-h-0">

        <div className="px-6 py-3 border-b border-slate-100">
          <img
            src={BhelLogo}
            alt="BHEL Logo"
            className="h-12 object-contain"
          />
        </div>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto px-4 py-5 space-y-2">

          {menuItems.map((item, index) => {

            const Icon = iconMap[item.value];

            const isActive = isMenuActive(item);

            const isOpen =
              openMenus.includes(item.value);

            return (

              <div key={index} className="pr-2">

                <div
                  onClick={() => {
                    if (item?.hasChildren) {
                      toggleMenu(item.value);
                    } else {
                      navigate(item.path);
                    }
                  }}
                  className={`relative group rounded-xl transition-all duration-200 cursor-pointer

    ${isActive
                      ? "bg-blue-50 shadow-md"
                      : "hover:bg-slate-100"
                    }

    ${item?.hasChildren && isOpen
                      ? "bg-slate-50"
                      : ""
                    }
  `}
                >

                  {isActive && (
                    <span className="absolute left-1 top-2 bottom-2 w-1 rounded-full bg-blue-600" />
                  )}

                  <div className="flex items-center justify-between px-4 py-3">

                    <div className="flex items-center gap-3">

                      {Icon && (
                        <Icon
                          size={19}
                          strokeWidth={2}
                          className={`
                            transition-colors
                            duration-200

                            ${isActive
                              ? "text-blue-600"
                              : "text-slate-500 group-hover:text-blue-600"
                            }
                        `}
                        />
                      )}

                      <span
                        className={`
                          text-[16px]
                          font-medium
                          transition-colors

                          ${isActive
                            ? "text-blue-700"
                            : "text-slate-700"
                          }
                      `}
                      >
                        {item.name}
                      </span>

                    </div>

                    {item?.hasChildren && (

                      <ChevronRight
                        size={17}
                        className={`
                          text-slate-400
                          transition-transform
                          duration-300

                          ${isOpen
                            ? "rotate-90"
                            : ""
                          }
                      `}
                      />

                    )}

                  </div>

                  {/* ================= FIRST LEVEL ================= */}
                  {item?.hasChildren && isOpen && (
                    <div className="px-3 pb-3 animate-in fade-in duration-200">

                      {item.children.map((child) => {

                        const isChildActive =
                          location.pathname.startsWith(child.path);

                        const isChildOpen =
                          openMenus.includes(child.value);

                        return (

                          <div key={child.name} className="mt-1">

                            <div
                              onClick={(e) => {
                                e.stopPropagation();

                                if (child?.hasChildren) {
                                  toggleMenu(child.value);
                                } else {
                                  navigate(child.path);
                                }
                              }}
                              className={`
                group
                flex
                items-center
                justify-between
                rounded-lg
                px-4
                py-2.5
                ml-4
                border-l
                border-slate-200
                cursor-pointer
                transition-all
                duration-200

                ${isChildActive && !child?.hasChildren
                                  ? "bg-blue-50 text-blue-700 border-blue-500"
                                  : "hover:bg-slate-100 text-slate-600"
                                }
            `}
                            >

                              <div className="flex items-center gap-2">
                                <span
                                  className={`
    w-2
    h-2
    rounded-full
    flex-shrink-0
    ${isChildActive
                                      ? "bg-blue-600"
                                      : "bg-slate-300 group-hover:bg-blue-500"
                                    }
  `}
                                />

                                <span className="text-sm font-medium">
                                  {child.name}
                                </span>

                              </div>

                              {child?.hasChildren && (

                                <ChevronRight
                                  size={15}
                                  className={`
                    text-slate-400
                    transition-transform
                    duration-300

                    ${isChildOpen
                                      ? "rotate-90"
                                      : ""
                                    }
                `}
                                />

                              )}

                            </div>

                            {/* ================= LEVEL 2 ================= */}
                            {child?.hasChildren && isChildOpen && (

                              <div className="ml-8 mt-1 space-y-1 border-l border-slate-200 pl-3">

                                {child.children.map((nested) => {

                                  const isNestedActive =
                                    location.pathname.startsWith(nested.path);

                                  const isNestedOpen =
                                    openMenus.includes(nested.value);

                                  return (

                                    <div key={nested.name}>

                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          if (nested?.hasChildren) {
                                            toggleMenu(nested.value);
                                          } else {
                                            navigate(nested.path);
                                          }
                                        }}
                                        className={`
                group
                flex
                items-center
                justify-between
                rounded-lg
                px-3
                py-2
                cursor-pointer
                transition-all
                duration-200

                ${isNestedActive && !nested?.hasChildren
                                            ? "bg-blue-50 text-blue-700"
                                            : "hover:bg-slate-100 text-slate-600"
                                          }
            `}
                                      >

                                        <div className="flex items-center gap-2">

                                          <span
                                            className={`
                    h-1.5
                    w-1.5
                    rounded-full

                    ${isNestedActive
                                                ? "bg-blue-600"
                                                : "bg-slate-400 group-hover:bg-blue-500"
                                              }
                `}
                                          />

                                          <span className="text-[13px] font-medium">
                                            {nested.name}
                                          </span>

                                        </div>

                                        {nested?.hasChildren && (

                                          <ChevronRight
                                            size={14}
                                            className={`
                    text-slate-400
                    transition-transform
                    duration-300
                    ${isNestedOpen
                                                ? "rotate-90"
                                                : ""
                                              }
                `}
                                          />

                                        )}

                                      </div>

                                      {/* ================= LEVEL 3 ================= */}
                                      {nested?.hasChildren && isNestedOpen && (

                                        <div className="ml-8 mt-1 space-y-1 border-l border-slate-200 pl-3">

                                          {nested.children.map((third) => {

                                            const isThirdActive =
                                              location.pathname.startsWith(third.path);

                                            return (

                                              <div
                                                key={third.name}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  navigate(third.path);
                                                }}
                                                className={`
              group
              flex
              items-center
              gap-2
              rounded-lg
              px-3
              py-2
              cursor-pointer
              transition-all
              duration-200

              ${isThirdActive
                                                    ? "bg-blue-50 text-blue-700 font-medium"
                                                    : "hover:bg-slate-100 text-slate-600"
                                                  }
          `}
                                              >

                                                <span
                                                  className={`
                h-1.5
                w-1.5
                rounded-full

                ${isThirdActive
                                                      ? "bg-blue-600"
                                                      : "bg-slate-400 group-hover:bg-blue-500"
                                                    }
            `}
                                                />

                                                <span className="text-[13px]">
                                                  {third.name}
                                                </span>

                                              </div>

                                            );

                                          })}

                                        </div>

                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className="px-4 border-t py-4 items-center"> */}
      <div className="border-t border-slate-200 p-4 shrink-0 bg-white">
        <div className="flex flex-row justify-between">
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-sm">{user?.role}</div>
            <div className="text-sm text-gray-500 ">
              {user?.email}
            </div>
          </div>

          <div className="flex items-center pr-4">
            <LogOut
              size={18}
              onClick={handleLogout}
              className="flex-shrink-0 cursor-pointer text-slate-500 hover:text-red-500 transition-colors duration-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;

// export default SideBar;
